import $ from 'jquery';
import lity from 'lity';

class Lity {
  constructor() {
    this.team();
  }

  team() {
    this.team = $('.js-team-members');

    if (!this.team.length) {
      return;
    }

    this.teamMember = this.team.find('.js-team-member');

    this.teamMember.on('click', '.js-team-member-image', e => {
      const target = $(e.target);

      if (
        target.hasClass('c-social-links') ||
        target.closest('.c-social-links').length
      ) {
        return;
      }

      const self = $(e.currentTarget);
      const memberBioId = self.data('team-member');
      const memberBio = this.teamMember.find(
        `.js-team-member-bio${memberBioId}`,
      );

      if (memberBio.length) {
        lity(memberBio);
      }
    });

    $(document).on('lity:ready', (event, instance) => {
      const lightbox = instance.element();
      const opener = instance.opener();

      if (!$('.lity-team').length) {
        if (
          opener.length &&
          (opener.hasClass('js-modal-video-btn') ||
            opener.closest('.js-page-hero').length)
        ) {
          return;
        }

        lightbox.addClass('lity-team');
      }
    });
  }
}

export default new Lity();



// WEBPACK FOOTER //
// ./src/scripts/modules/lity.js